import React, { useState, useEffect, useRef, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { Container, Row, Col, Modal, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import PaginationComponent from "../../Component/Pagination/PaginationControls";
import { fetchAllSIP } from "../../Actions/adminActions";
import moment from "moment";
import apiCall from "../../API/API";
import { toast, ToastContainer } from "react-toastify";

const ActiveSIP_Details = () => {
  const location = useLocation();
  const { sip_Id } = location.state || {};
  const [SipData, setSipData] = useState([]);
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [selectedInstallment, setSelectedInstallment] = useState(null);
  const [username, setUsername] = useState("");

  const fetchSIP = async () => {
    const { data, error } = await apiCall(
      "GET",
      `/get_all_Sips?sip_Id=${sip_Id}`,
      null,
      false
    );
    if (error) {
      toast.error(error.message);
    } else {
      setSipData(data);
      setUsername(data?.data?.[0]?.username || "");
    }
  };
  useEffect(() => {
    fetchSIP();
  }, [sip_Id]);

  const handlePay = async () => {
    console.log("sip_Id", sip_Id);

    try {
      const { data, error } = await apiCall("POST", `/payinstallment`, {
        installment_id: selectedInstallment?.installment_id,
        sip_Id: sip_Id,
      });
      if (error) {
        toast.error(error.message || "An error occurred");
      } else {
        toast.success(data.message || "Paid successfully");
        fetchSIP();
        setShowModal(false);
      }
    } catch (error) {
      toast.error(error.message || "An error occurred");
    }
  };

  const handleOpenModal = (installment) => {
    setSelectedInstallment(installment);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <React.Fragment>
      <Container>
        <h3>Installment Details</h3>
        <hr></hr>

        <div id="directIncomeDiv">
          <Row id="directTableRow" className="">
            <Col md="12" className="p-0">
              <div style={{ width: "100%" }}>
                <table>
                  <tr>
                    <th style={{ textAlign: "center" }}>Installment Id</th>
                    <th style={{ textAlign: "center" }}>Installment Amount</th>
                    <th style={{ textAlign: "center" }}>Installment Date</th>
                    <th style={{ textAlign: "center" }}>Paid Date</th>
                    <th style={{ textAlign: "center" }}>Status</th>
                  </tr>
                  {Array.isArray(SipData?.data?.[0]?.installment) &&
                    SipData?.data?.[0]?.installment?.map((x, i) => {
                      return (
                        <tr>
                          <td style={{ textAlign: "center" }}>
                            {x?.installment_id}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {x?.installment_amount}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {" "}
                            {moment(x?.installment_Date).format(
                              "MM-DD-YYYY   &   HH:mm"
                            )}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {x?.paid_Date
                              ? moment(x?.paid_Date).format(
                                  "MM-DD-YYYY   &   HH:mm"
                                )
                              : " "}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {x?.status === 0 ? (
                              <Button
                                variant="primary"
                                onClick={() => handleOpenModal(x)}
                              >
                                Pay
                              </Button>
                            ) : (
                              "Paid"
                            )}
                          </td>
                        </tr>
                      );
                    })}
                </table>
              </div>
            </Col>
          </Row>
        </div>
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Payment</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              Are you sure you want to pay for installment ID:{" "}
              {selectedInstallment?.installment_id}?
            </p>
            <p>Username: {username}</p>
            <p>Installment Amount: {selectedInstallment?.installment_amount}</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handlePay}>
              Confirm Pay
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </React.Fragment>
  );
};

export default ActiveSIP_Details;
